import React from 'react';
import { Typography, Divider } from 'antd';
import { useLanguage } from '../store/LanguageContext';
import { contactEmail } from '../utils/site';

const { Title, Paragraph } = Typography;

const DisclaimerPage: React.FC = () => {
  const { t } = useLanguage();
  const email = contactEmail();

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px 80px' }}>
      <Title level={2}>{t('disclaimer.title')}</Title>
      <Divider />

      <Title level={4}>{t('disclaimer.section1Title')}</Title>
      <Paragraph>{t('disclaimer.section1Content')}</Paragraph>

      <Title level={4}>{t('disclaimer.section2Title')}</Title>
      <Paragraph>{t('disclaimer.section2Content')}</Paragraph>

      <Title level={4}>{t('disclaimer.section3Title')}</Title>
      <Paragraph>{t('disclaimer.section3Content')}</Paragraph>

      <Title level={4}>{t('disclaimer.section4Title')}</Title>
      <Paragraph>{t('disclaimer.section4Content')}</Paragraph>
      <Paragraph>
        <ul>
          <li>{t('disclaimer.submitLink')}：<a href="/submit">/submit</a></li>
          <li>{t('disclaimer.emailLink')}：<a href={`mailto:${email}`}>{email}</a></li>
        </ul>
      </Paragraph>

      <Divider />
      <Paragraph type="secondary" style={{ fontSize: 12 }}>
        {t('disclaimer.effectiveNote')}
      </Paragraph>
    </div>
  );
};

export default DisclaimerPage;
